import { render, staticRenderFns } from "./MyAvatar.vue?vue&type=template&id=3d985e4b&"
import script from "./MyAvatar.vue?vue&type=script&lang=js&"
export * from "./MyAvatar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports